<template lang="pug">
    .card-image(v-if="image")
        figure(:style="{ height: `${height}px` }")
            img(
                v-lazy="image"
                v-if="maxWidth"
                :title="title"
                :style="{ width: `${width}px`, height: `${height}px` }"
                rel="noopener"
            )

</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'

export default {
    name: 'CardImage',
    data() {
        return {
            // maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        }
    },
    props: {
        image: {
            type: Object,
            required: true,
        },
        content: {
            type: Object,
            required: true,
        },
        maxWidth: {
            type: Number,
        },
        shadow: {
            type: String,
            default: 'box-shadow-2',
        }
    },
    computed: {
        title() {
            return get(this.content, 'title')
        },
        text() {
            return get(this.content, 'text')
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width)
            else return this.maxWidth
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
    },
}
</script>

<style lang="sass" scoped>

    // @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'

    .content .card-image
        // width: 100%
        margin: auto
        img
            // width: auto
            // height: initial
            width: 100%
            height: auto
            // border-radius: 4px
            display: inline-block
            &[lazy=loading]
                box-shadow: none
            &[lazy=loaded]
                // height: initial !important
                // width: initial !important
                &.box-shadow-2
                    box-shadow: $box-shadow-2
        p
            margin-bottom: 0
            font-size: .8rem
        small
            font-size: .65rem
        figure
            display: block
            background: #eeeeee
            border-radius: 4px
            margin-bottom: 2px
</style>
